<script>
import { modalState, hideModal } from "@app/store/modalStore.svelte.js";
import { lockState } from "@app/store/lockStore.svelte.js";
import { authState } from "@app/store/authStore.svelte.js";
import { externalDataState } from "@app/store/externalDataStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
import { toast } from "@zerodevx/svelte-toast";
import { styleState } from "@app/store/styleStore.svelte.js";
import { fade } from "svelte/transition";
import Swal from "sweetalert2";
import { SWAL_BASE, SWAL_CLASSES } from "@app/lib/swalClasses.js";
import * as m from "@app/paraglide/messages.js";
import throttle from "just-throttle";
import { activateSubscription } from "@app/lib/activateSubscription.js";
import axios from "axios";

import encode from "@cclib/functions/encode.js";
import defaults from "@cclib/lib/defaults.js";
import tcLib from "@cclib/lib/timecode.js";
import _Event from "@cclib/classes/event.js";
import offset from "@cclib/functions/events/tcOffset.js";
import tcMultiply from "@cclib/functions/special/tcMultiply.js";
import orderByTime from "@cclib/functions/eventGroups/orderByTime.js";
import removeHtmlEntities from "@cclib/functions/eventGroups/removeHtmlEntities.js";
import replaceTrialText from "@cclib/functions/eventGroups/replaceTrialText.js";
import wrapStyledTextWithSpan from "@cclib/functions/quill/wrapStyledTextWithSpan.js";

let progress = $state(0),
    statusMsg = m.work_order_publish_status_starting();
let description = $state(JSON.parse(externalDataState.rawDescription));
let task = description.task || "edit";
let username = "",
    password = "",
    authLoginFlag = false;

let playerWidth = document.getElementById("PlayerWrapper").clientWidth;
let playerHeight = document.getElementById("PlayerWrapper").clientHeight;
let ignoreAll = false;
console.info(description);

if (authState.status === "in_trial") {
    showTrialWarning();
}

function showTrialWarning() {
    Swal.fire({
        ...SWAL_BASE,
        titleText: m.work_order_publish_trial_title(),
        text: m.work_order_publish_trial_text(),
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: m.work_order_publish_activate_account(),
        denyButtonText: m.work_order_publish_continue_trial(),
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: SWAL_CLASSES.trial,
    })
        .then((result) => {
            if (result.isConfirmed) {
                activateSubscription();
            }
        })
        .catch((err) => {
            console.log(err);
            console.log(err.message);
        });
}

async function updateStatus(statusInfo) {
    progress = statusInfo.progress;
    statusMsg = statusInfo.msg;
}

async function cancelExport(eventGroupId, eventId) {
    toast.push(m.work_order_publish_export_aborted(), { classes: ["toast-warning"] });

    projectState.selected = eventGroupId;
    eventGroupState[projectState.selected].selected = [eventId];
    setTimeout(() => {
        const selectedIndex =
            eventGroupState[projectState.selected].selected[0];
        window.dispatchEvent(
            new CustomEvent("scrollToVirtualListItem", {
                detail: { index: selectedIndex },
            }),
        );

        if (lockState.video && player) {
            player.currentTime =
                eventGroupState[projectState.selected].events[
                    selectedIndex
                ].start;
        }
    }, 250);

    hideModal();
}
function alertUser(msg) {
    let response = Swal.fire({
        ...SWAL_BASE,
        titleText: m.work_order_publish_pre_checks_title(),
        text: msg,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: m.work_order_publish_abort_button(),
        denyButtonText: m.work_order_publish_ignore_button(),
        cancelButtonText: m.work_order_publish_ignore_all_button(),
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: SWAL_CLASSES.precheck,
    }).then((result) => {
        if (result.isConfirmed) {
            return true;
        } else if (result.isDenied) {
            return false;
        } else if (result.isDismissed) {
            ignoreAll = true;
            return false;
        }
    });

    return response;
}

async function preExportCheck(events) {
    for (let i = 0; i < events.length; i++) {
        if (!ignoreAll) {
            if (events[i].text) {
                if (isNaN(events[i].start)) {
                    if (
                        await alertUser(
                            m.work_order_publish_missing_start_time({ index: i + 1 }),
                        )
                    ) {
                        return {
                            err: true,
                            eventId: i,
                        };
                    }
                } else if (isNaN(events[i].end)) {
                    if (
                        await alertUser(
                            m.work_order_publish_missing_end_time({ index: i + 1 }),
                        )
                    ) {
                        return {
                            err: true,
                            eventId: i,
                        };
                    }
                } else if (events[i].start === events[i].end) {
                    if (
                        await alertUser(
                            m.work_order_publish_same_start_end({ index: i + 1 }),
                        )
                    ) {
                        return {
                            err: true,
                            eventId: i,
                        };
                    }
                } else if (events[i].start > events[i].end) {
                    if (
                        await alertUser(
                            m.work_order_publish_start_greater_end({ index: i + 1 }),
                        )
                    ) {
                        return {
                            err: true,
                            eventId: i,
                        };
                    }
                } else if (i > 0 && events[i].start < events[i - 1].end) {
                    /* Adding check in case overlap is less than a frame */
                    if (
                        events[i - 1].end - events[i].start <
                        1 / projectState.frameRate
                    ) {
                        events[i].start = events[i - 1].end;
                    } else if (
                        await alertUser(
                            m.work_order_publish_overlap_previous({ index: i + 1 }),
                        )
                    ) {
                        return {
                            err: true,
                            eventId: i,
                        };
                    }
                }
            } else {
                if (
                    await alertUser(
                        m.work_order_publish_no_text({ index: i + 1 }),
                    )
                ) {
                    return {
                        err: true,
                        eventId: i,
                    };
                }
            }
        }
    }

    return {
        err: false,
    };
}

async function getUserAuth() {
    console.log("Get User Authentication");
    let usernameInput;
    let passwordInput;
    let swalRes = await Swal.fire({
        ...SWAL_BASE,
        title: m.work_order_publish_auth_title(),
        html: `
                            <div class="mb-3">
                                <label for="username" class="form-label">${m.work_order_publish_auth_email_label()}</label>
                                <input type="text" id="username" class="form-control" placeholder="${m.work_order_publish_auth_username_placeholder()}">                                
                            </div>
                            <div class="mb-3">
                                <label for="password" class="form-label">${m.work_order_publish_auth_password_label()}</label>
                                <input type="password" id="password" class="form-control" placeholder="${m.work_order_publish_auth_password_placeholder()}">                                
                            </div>`,
        confirmButtonText: m.work_order_publish_auth_confirm(),
        focusConfirm: false,
        customClass: SWAL_CLASSES.ok,
        didOpen: () => {
            const popup = Swal.getPopup();
            usernameInput = popup.querySelector("#username");
            passwordInput = popup.querySelector("#password");
            usernameInput.onkeyup = (event) =>
                event.key === "Enter" && Swal.clickConfirm();
            passwordInput.onkeyup = (event) =>
                event.key === "Enter" && Swal.clickConfirm();
        },
        preConfirm: () => {
            const username = usernameInput.value;
            const password = passwordInput.value;
            if (!username || !password) {
                Swal.showValidationMessage(
                    m.work_order_publish_auth_validation(),
                );
            }
            return {
                username,
                password,
            };
        },
    });

    username = swalRes.value.username;
    password = swalRes.value.password;
    authLoginFlag = true;
    return;
}

async function publish() {
    try {
        await updateStatus({
            progress: 5,
            statusMsg: m.work_order_publish_status_starting_publish(),
        });

        if (task === "review") {
            console.log("REVIEW TASK");
            await updateStatus({
                progress: 10,
                statusMsg: m.work_order_publish_status_review_tracks(),
            });
            for (let track of description.tracks) {
                console.log(`Publishing track:`, track);
                if (track.publishOptions && track.publishOptions.length > 0) {
                    for (let publishOption of track.publishOptions) {
                        console.log("actioning publish:", publishOption);
                        if (publishOption.url) {
                            console.log("Publish URL:", publishOption.url);
                            if (publishOption.auth && !authLoginFlag) {
                                console.log("Auth Login Flag:", authLoginFlag);
                                await getUserAuth();
                            }

                            let res = await axios.post(
                                publishOption.url,
                                track,
                                {
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                    auth: {
                                        username: username,
                                        password: password,
                                    },
                                },
                            );

                            console.log(res);
                        }
                    }
                }
            }

            await updateStatus({
                progress: 60,
                statusMsg: m.work_order_publish_status_review_all(),
            });

            if (
                description.publishOptions &&
                description.publishOptions.length > 0
            ) {
                for (let publishOption of description.publishOptions) {
                    if (publishOption.url) {
                        if (publishOption.auth && !authLoginFlag) {
                            await getUserAuth();
                        }

                        await axios.post(
                            publishOption.url,
                            {
                                tracks: description.tracks,
                            },
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                auth: {
                                    username: username,
                                    password: password,
                                },
                            },
                        );
                    }
                }
            }
        } else {
            console.log("Edit Work Order");
            await updateStatus({
                progress: 10,
                statusMsg: m.work_order_publish_status_edit_tracks(),
            });
            for (let track of description.tracks) {
                console.log(`Publishing track:`, track);
                if (
                    track.publishOptions &&
                    track.publishOptions.length > 0 &&
                    track.status === "Publish"
                ) {
                    await updateStatus({
                        progress: progress + 5,
                        statusMsg: m.work_order_publish_status_edit_tracks(),
                    });
                    for (let publishOption of track.publishOptions) {
                        console.log("actioning publish:", publishOption);
                        if (publishOption.url) {
                            console.log("Publish URL:", publishOption.url);
                            if (publishOption.auth && !authLoginFlag) {
                                console.log("Auth Login Flag:", authLoginFlag);
                                await getUserAuth();
                            }

                            /* Find the Index of the Event Group to Publish */
                            let eventGroupIndex = eventGroupState.findIndex(
                                (group) => {
                                    return group.id === track.id;
                                },
                            );

                            if (eventGroupIndex === -1) {
                                throw new Error(
                                    m.work_order_publish_event_group_removed(),
                                );
                            }

                            let copyOfEventGroup = JSON.parse(
                                JSON.stringify(
                                    eventGroupState[eventGroupIndex],
                                ),
                            );
                            copyOfEventGroup = orderByTime(copyOfEventGroup);
                            copyOfEventGroup =
                                removeHtmlEntities(copyOfEventGroup);
                            let preCheckResult = await preExportCheck(
                                copyOfEventGroup.events,
                            );

                            if (preCheckResult.err) {
                                cancelExport(
                                    eventGroupIndex,
                                    preCheckResult.eventId,
                                );
                            } else {
                                if (publishOption.offset) {
                                    copyOfEventGroup.events.forEach(
                                        (event, index, events) => {
                                            events[index] = offset(
                                                event,
                                                tcLib.tcToSec(
                                                    publishOption.offset,
                                                    publishOption.frameRate,
                                                    publishOption.dropFrame,
                                                ),
                                                publishOption.offsetType ||
                                                    "add",
                                            );
                                        },
                                    );
                                }

                                if (
                                    publishOption.tcMultiplier &&
                                    publishOption.tcMultiplier != 0 &&
                                    publishOption.tcMultiplier != 1
                                ) {
                                    copyOfEventGroup = tcMultiply(
                                        copyOfEventGroup,
                                        publishOption.tcMultiplier,
                                    );
                                }

                                let exportOptions = new defaults.options({
                                    profile: publishOption.profile,
                                    formatOptions: publishOption.options,
                                    frameRate: publishOption.frameRate,
                                    dropFrame: publishOption.dropFrame,
                                    target_profile: publishOption.profile,
                                    source_profile: "closedCaptionProject",
                                    window: {
                                        width: styleState.width,
                                        height: styleState.height,
                                        xPadding: styleState.xPadding,
                                        yPadding: styleState.yPadding,
                                    }
                                });

                                if (authState.status === "in_trial") {
                                    copyOfEventGroup =
                                        replaceTrialText(copyOfEventGroup);
                                }

                                copyOfEventGroup.events.forEach(
                                    (event, index, events) => {
                                        events[index].text =
                                            wrapStyledTextWithSpan(event.text);
                                    },
                                );

                                track.output = await encode(
                                    copyOfEventGroup,
                                    exportOptions,
                                );

                                let res = await axios.post(
                                    publishOption.url,
                                    track,
                                    {
                                        headers: {
                                            "Content-Type": "application/json",
                                        },
                                        auth: {
                                            username: username,
                                            password: password,
                                        },
                                    },
                                );

                                console.log(res);
                            }
                        }
                    }
                }
            }

            await updateStatus({
                progress: progress + 5,
                statusMsg: m.work_order_publish_status_edit_all(),
            });

            if (
                description.publishOptions &&
                description.publishOptions.length > 0
            ) {
                for (let publishOption of description.publishOptions) {
                    if (publishOption.url) {
                        if (publishOption.auth && !authLoginFlag) {
                            await getUserAuth();
                        }

                        for (let track of description.tracks) {
                            if (track.status === "Publish") {
                                /* Find the Index of the Event Group to Publish */
                                let eventGroupIndex = eventGroupState.findIndex(
                                    (group) => {
                                        return group.id === track.id;
                                    },
                                );

                                if (eventGroupIndex === -1) {
                                    throw new Error(
                                        m.work_order_publish_event_group_removed(),
                                    );
                                }

                                let copyOfEventGroup = JSON.parse(
                                    JSON.stringify(
                                        eventGroupState[eventGroupIndex],
                                    ),
                                );
                                copyOfEventGroup =
                                    orderByTime(copyOfEventGroup);
                                copyOfEventGroup =
                                    removeHtmlEntities(copyOfEventGroup);
                                let preCheckResult = await preExportCheck(
                                    copyOfEventGroup.events,
                                );

                                if (preCheckResult.err) {
                                    cancelExport(
                                        eventGroupIndex,
                                        preCheckResult.eventId,
                                    );
                                } else {
                                    if (publishOption.offset) {
                                        copyOfEventGroup.events.forEach(
                                            (event, index, events) => {
                                                events[index] = offset(
                                                    event,
                                                    tcLib.tcToSec(
                                                        publishOption.offset,
                                                        publishOption.frameRate,
                                                        publishOption.dropFrame,
                                                    ),
                                                    publishOption.offsetType ||
                                                        "add",
                                                );
                                            },
                                        );
                                    }

                                    if (
                                        publishOption.tcMultiplier &&
                                        publishOption.tcMultiplier != 0 &&
                                        publishOption.tcMultiplier != 1
                                    ) {
                                        copyOfEventGroup = tcMultiply(
                                            copyOfEventGroup,
                                            publishOption.tcMultiplier,
                                        );
                                    }

                                    let exportOptions = new defaults.options({
                                        profile: publishOption.profile,
                                        formatOptions: publishOption.options,
                                        frameRate: publishOption.frameRate,
                                        dropFrame: publishOption.dropFrame,
                                        target_profile: publishOption.profile,
                                        source_profile: "closedCaptionProject",
                                        window: {
                                            width: styleState.width,
                                            height: styleState.height,
                                            xPadding: styleState.xPadding,
                                            yPadding: styleState.yPadding,
                                        },
                                    });

                                    if (authState.status === "in_trial") {
                                        copyOfEventGroup =
                                            replaceTrialText(copyOfEventGroup);
                                    }

                                    copyOfEventGroup.events.forEach(
                                        (event, index, events) => {
                                            events[index].text =
                                                wrapStyledTextWithSpan(
                                                    event.text,
                                                );
                                        },
                                    );

                                    track.output = await encode(
                                        copyOfEventGroup,
                                        exportOptions,
                                    );
                                }
                            }
                        }

                        await axios.post(
                            publishOption.url,
                            {
                                tracks: description.tracks.filter((track) => {
                                    return track.status === "Publish";
                                }),
                            },
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                auth: {
                                    username: username,
                                    password: password,
                                },
                            },
                        );
                    }
                }
            }
        }

        await updateStatus({
            progress: 80,
            statusMsg: m.work_order_publish_status_finalizing(),
        });

        if (description.publishAlertSuccess) {
            await Swal.fire({ ...SWAL_BASE, ...description.publishAlertSuccess });
        }

        toast.push(m.work_order_publish_success(), {
            classes: ["toast-success"],
        });

        await updateStatus({
            progress: 100,
            statusMsg: m.work_order_publish_status_complete(),
        });

        /* Redirect */
        if (description.redirectUrl) {
            //window.location.replace(description.redirectUrl);
        }
    } catch (err) {
        console.info(err, err.message);
        if (description.publishAlertError) {
            await Swal.fire({ ...SWAL_BASE, ...description.publishAlertError });
        }

        toast.push(m.work_order_publish_failed({ message: err.message }), {
            classes: ["toast-danger"],
        });
    } finally {
        hideModal();
    }
}
</script>

<div
    transition:fade={{ duration: 100 }}
    class="modal {modalState.selected === 'workOrderPublish'
        ? 'show d-block'
        : ''}"
    role="dialog"
    tabindex="-1"
    id="PublishExternalProjectModal"
    aria-labelledby="publishModalTitle"
    aria-describedby="publishModalDescription">
    <div
        class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
        role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="publishModalTitle">
                    {m.work_order_publish_title()}
                </h4>
                <button
                    type="button"
                    class="btn-close"
                    aria-label={m.work_order_publish_close_label()}
                    id="publishModalClose"
                    onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <p id="publishModalDescription">{description.publishText}</p>
                <table class="table" aria-label={m.work_order_publish_track_status_table_label()}>
                    <thead>
                        <tr>
                            <th scope="col">{m.work_order_publish_table_name()}</th>
                            <th scope="col">{m.work_order_publish_table_type()}</th>
                            <th scope="col">{m.work_order_publish_table_status()}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each description.tracks as track, index (track.id ?? index)}
                            <tr>
                                <td>{track.displayName}</td>
                                <td>{track.type}</td>
                                <td>
                                    <select
                                        class="form-select"
                                        bind:value={track.status}
                                        id="trackStatus{index}"
                                        aria-label={m.work_order_publish_status_for_track({ name: track.displayName })}>
                                        {#if task === "review"}
                                            <option>{m.work_order_publish_option_pass()}</option>
                                            <option>{m.work_order_publish_option_fail()}</option>
                                            <option>{m.work_order_publish_option_edit_required()}</option>
                                            <option>{m.work_order_publish_option_refer_supervisor()}</option>
                                        {:else}
                                            <option>{m.work_order_publish_option_publish()}</option>
                                            <option>{m.work_order_publish_option_do_not_publish()}</option>
                                        {/if}
                                    </select>
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <button
                    type="button"
                    id="publishModalCancel"
                    class="btn btn-light"
                    disabled={progress > 0}
                    onclick={hideModal}>{m.work_order_publish_cancel_button()}</button>
                <button
                    type="button"
                    id="publishModalPublish"
                    class="btn btn-primary"
                    disabled={progress > 0}
                    onclick={() => publish()}>{m.work_order_publish_publish_button()}</button>
            </div>
        </div>
    </div>
</div>
